import React from 'react';
import VisitorListing from '../components/visitor/visitorListing/visitorListing';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';

function Visitor() {

    const canReadVisitor = hasPermission("Visitors", "Visitor", "read");
    const navigate = useNavigate();

    if (!canReadVisitor) {
        navigate('/no-permission')
    }

    return (
        <VisitorListing />
    )
}

export default Visitor